import { extend, mergeData } from '../../vue';
import { NAME_FORM_SELECT_OPTION } from '../../constants/components';
import { PROP_TYPE_BOOLEAN, PROP_TYPE_ANY } from '../../constants/props';
import { makePropsConfigurable, makeProp } from '../../utils/props';

// --- Props ---

const props = makePropsConfigurable({
  disabled: makeProp(PROP_TYPE_BOOLEAN, false),
  value: makeProp(PROP_TYPE_ANY, undefined, true) // Required
}, NAME_FORM_SELECT_OPTION);

// --- Main component ---

// @vue/component
const BFormSelectOption = /*#__PURE__*/extend({
  name: NAME_FORM_SELECT_OPTION,
  functional: true,
  props,
  render(h, _ref) {
    let {
      props,
      data,
      children
    } = _ref;
    const {
      value,
      disabled
    } = props;
    return h('option', mergeData(data, {
      attrs: {
        disabled
      },
      domProps: {
        value
      }
    }), children);
  }
});

export { BFormSelectOption, props };
